import { isNewsId, isNewsType, type NewsCatalogItem } from "./types";

/**
 * Source of truth for published news metadata.
 * Add a row here, a page under pages/news, and i18n keys — then deploy.
 */
export const NEWS_CATALOG: readonly NewsCatalogItem[] = [
  {
    id: "credits-for-form-and-stories",
    type: "news",
    publishedAt: "2026-09-10T22:20:00.000Z",
  },
];

function comparePublishedAtDesc(a: NewsCatalogItem, b: NewsCatalogItem): number {
  if (a.publishedAt === b.publishedAt) {
    return a.id < b.id ? 1 : a.id > b.id ? -1 : 0;
  }
  return a.publishedAt < b.publishedAt ? 1 : -1;
}

export const NEWS_CATALOG_BY_PUBLISHED_DESC: readonly NewsCatalogItem[] = [
  ...NEWS_CATALOG,
].sort(comparePublishedAtDesc);

export const NEWS_CATALOG_BY_ID: ReadonlyMap<string, NewsCatalogItem> = new Map(
  NEWS_CATALOG.map((item) => [item.id, item])
);

export const LATEST_NEWS_ITEM: NewsCatalogItem | null =
  NEWS_CATALOG_BY_PUBLISHED_DESC[0] ?? null;

export function getNewsCatalogItem(id: string): NewsCatalogItem | undefined {
  return NEWS_CATALOG_BY_ID.get(id);
}

export function assertNewsCatalogValid(items: readonly NewsCatalogItem[]): void {
  const seen = new Set<string>();
  for (const item of items) {
    if (!isNewsId(item.id)) {
      throw new Error(`Invalid news id "${item.id}"`);
    }
    if (seen.has(item.id)) {
      throw new Error(`Duplicate news id "${item.id}"`);
    }
    seen.add(item.id);
    if (!isNewsType(item.type)) {
      throw new Error(`Invalid news type "${item.type}" for "${item.id}"`);
    }
    if (Number.isNaN(Date.parse(item.publishedAt))) {
      throw new Error(`Invalid publishedAt for "${item.id}"`);
    }
  }
}

assertNewsCatalogValid(NEWS_CATALOG);
